import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { useTranslations } from "@jti/ui";
import { PriceTiersContext } from "../../../../utils/contexts/PriceTiersContext";
import { useAddProduct } from "../../../../utils/hooks/useAddProduct/useAddProduct";
import AddToCartButton from "./AddToCartButton";
const AddProductButton = ({ sku, bundle, onError, isLoaded, isDisabled, customBuyCtaLabel }) => {
    const { __ } = useTranslations();
    const { selectedPriceTier } = useContext(PriceTiersContext);
    const { isRunning, addProductToCart } = useAddProduct(sku, bundle, false, onError);
    const quantity = selectedPriceTier?.quantity ?? 1;
    const isLoading = isRunning || !isLoaded;
    return (_jsx(AddToCartButton, { onClick: () => addProductToCart(quantity), isLoading: isLoading, testId: "pdpAddToProduct", label: customBuyCtaLabel || __("product.button.addtocart"), isDisabled: isDisabled }));
};
export default AddProductButton;
//# sourceMappingURL=AddProductButton.js.map